import React from 'react';
import styled from 'styled-components';


const Path = styled.path`
  fill: ${({ theme }) => theme.colors.secondary()};
`;

function ArrowRight(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
    >
      <Path
        fillRule="evenodd"
        d="M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 1 1-1.414-1.414l4.95-4.95z"
      />
    </svg>
  );
}

export default ArrowRight;
